import { createApp } from "vue";
import { vfmPlugin } from "vue-final-modal";
import App from "./App.vue";
import axiosPlugin from "./axiosPlugin.mjs";
import router from "./router";
import store from "./store";
import translates from "./utilities/translates";
import { createI18n } from "vue-i18n";
import ToastPlugin from "vue-toast-notification";
import { initAnalytics } from "./utilities/analytics";
import "vue-toast-notification/dist/theme-bootstrap.css";
import "flatpickr/dist/flatpickr.min.css";
// Icone: pacchetto npm self-hosted, non un kit remoto. Le icone restano
// disponibili offline e non dipendono da servizi esterni (CSP-friendly).
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/regular.min.css";
import "./css/demo-mode.css";

const app = createApp(App);
// Create a new instance of VueI18n
const i18n = createI18n({
  locale: "it",
  fallbackLocale: "en",
  messages: translates,
});
app.use(axiosPlugin);
app.use(store);
app.use(ToastPlugin, {
  position: "bottom-right", // forza il posizionamento
  duration: 3500, // ms
  dismissible: true, // mostra la X
  pauseOnHover: true,
  queue: false,
});
app.use(i18n);
app.use(
  vfmPlugin({
    key: "$vfm",
    componentName: "VueFinalModal",
    dynamicContainerName: "ModalsContainer",
  })
);
// Modalità demo: marca il documento così il CSS centralizzato può nascondere
// le funzioni non previste dalla demo (vedi src/css/demo-mode.css).
if (process.env.VUE_APP_DEMO_MODE === "true") {
  document.documentElement.classList.add("demo-mode");
}

// Analytics (Umami): si attiva solo se configurato, non blocca mai l'avvio.
initAnalytics(router);

app.use(router).mount("#app");
// Rendi axios disponibile globalmente
// app.config.globalProperties.$axios = axios;
